import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { managementFinanceAPI } from "../../../../api/managementFinanceAPI";
import FinanceSummaryImg from '../../../../assets/images/FinanceSummary.png';
import FinanceSummary from '../../../chart/managementFinanceChart/FinanceSummary/FinanceSummary';
import AllPcode from "../../../allPcode";
import usePcode from "../../../../common/hooks/usePcode";
export default function FinanceSummaryModal() {

    const [isFetching, setIsFetching] = useState(false);
    const [showChart, setShowChart] = useState(false);
    const [data, setData] = useState([]);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);


    const handleData = (selectedPcode) => {
        setIsFetching(true);
        managementFinanceAPI.getFinanceSummary(selectedPcode).then((data) => {
            setData(data);
            setIsFetching(false);
        }).catch((e) => {
            toast.warn(e.message);
        })
    }

    useEffect(() => {
        handleData(selectedPcode);
    }, [selectedPcode])

    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("FinanceSummary");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);

    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#FinanceSummary">
                <img src={FinanceSummaryImg} className="card-img-top rounded rounded-5" alt="CaseReceived" />
            </a>
            <div className="modal fade" id="FinanceSummary" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Finance Summary</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-9 col-xl-9 col-xxl-9">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                                </div>
                                <FinanceSummary data={data} loading={isFetching} showChart={showChart} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}